import { formatDateTimeOrDash } from '#/utils/date';
import { ROUTES } from '#/config/routes';
import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import { createDocumentNavLinksColumn } from '#/modules/commonComponents/table/tableColumnHelpers';

export function buildInspectionKindColumns({ canEdit = false } = {}) {
  return [
    createDocumentNavLinksColumn({
      getDetailPath: (row) => ROUTES.inspectionKindDetail(row.id),
      getEditPath: (row) => ROUTES.inspectionKindEdit(row.id),
      canShowEdit: () => canEdit,
    }),
    {
      header: '代碼',
      accessorKey: 'code',
      size: 160,
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 220,
      meta: { cellClassName: 'td_left' },
    },
    {
      header: '狀態',
      accessorKey: 'status',
      size: 90,
      enableSorting: false,
    },
    {
      header: '版號',
      accessorKey: 'revisionNo',
      size: 80,
      enableSorting: false,
    },
    {
      header: '更新時間',
      id: 'updatedAt',
      accessorFn: (row) => row.record?.updatedAt,
      size: 180,
      enableSorting: false,
      cell: ({ row }) => formatDateTimeOrDash(row.original?.record?.updatedAt),
    },
  ];
}

export const inspectionKindSideMsgBlocks = [
  {
    fields: [
      { label: '代碼', value: 'code' },
      { label: '名稱', value: 'name' },
      { label: '狀態', value: entityStatusSideMsgValue },
      { label: '版號', value: 'revisionNo' },
      {
        label: '更新時間',
        value: (row) => formatDateTimeOrDash(row?.record?.updatedAt),
      },
    ],
  },
];
